// This file serves as entry point for the module and is used by Webpack. Webpack only allows .ts file as entry point.
// It is not used by the application directly, but it is used to bootstrap the module.
// Used for Standlone application bundling
import('./app');
